import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import mail from "../assets/images/icons/mail-send-envelope.svg";
import location from "../assets/images/icons/ubi.svg";
import call from "../assets/images/icons/call.svg";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import GetInTuch from "../components/getInTuch";

import { FiHexagon } from "../assets/icons/vander";
import Navbar from "../components/navbar";
import useStore from "../store/useStore";
import HeroComex from "../components/HeroComex";

export default function ContactUs() {
  const { contactosHeroes, getContactosHeroes } = useStore();
  const urlApi = "https://api.institucional.global.sidom.io";
  useEffect(() => {
    getContactosHeroes();
  }, [getContactosHeroes]);
  console.log("Contactos Heroes:", contactosHeroes);
  return (
    <div className="bg-sidom-blue">
      <Navbar />
      {contactosHeroes &&
        contactosHeroes.map((item, index) => (
          <HeroComex video={item.video[0]?.url} height="h-[300px]" />
        ))}

      <section className="relative md:pb-24 pb-16">
        <GetInTuch />
        <div className="container relative lg:mt-24 mt-16">
          <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-[30px]">
            <div className="text-center px-6">
              <div className="relative overflow-hidden text-transparent -m-3">
                <FiHexagon className="h-28 w-28  mx-auto rotate-[30deg]" />
                <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto text-orange-500 rounded-xl transition-all duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
                  <img src={call} alt="Teléfono" className="h-8 w-8" />
                </div>
              </div>

              <div className="content mt-7">
                <h5 className="title text-sidom-light text-lg font-medium">
                  Teléfono
                </h5>
                <p className="text-sidom-light  mt-3">
                  Estamos a disposición para iniciar el salto al siguiente
                  Nivel.
                </p>
                <a
                  href="tel:+5491137241700"
                  className=" text-sidom-orange text-nowrap block mb-2 mt-3"
                >
                  Teléfono: +54 11 3724 1700
                </a>
              </div>
            </div>

            <div className="text-center px-6">
              <div className="relative overflow-hidden text-transparent -m-3">
                <FiHexagon className="h-28 w-28  mx-auto rotate-[30deg]" />
                <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto text-orange-500 rounded-xl transition-all duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
                  {/* Correo: icono sobre moderno */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="h-8 w-8"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25H4.5a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-.876 1.8l-7.5 5.625a2.25 2.25 0 01-2.748 0l-7.5-5.625a2.25 2.25 0 01-.876-1.8V6.75"
                    />
                  </svg>
                </div>
              </div>

              <div className="content mt-7">
                <h5 className="title  text-sidom-light text-lg font-medium">
                  Email
                </h5>
                <p className="text-sidom-light  mt-3">
                  Nuestro equipo responderá de inmediato a su solicitud.
                </p>

                <div className="mt-5">
                  <Link
                    to="mailto:contact@example.com"
                    className="text-orange-500 hover:text-orange-500 after:bg-orange-500 transition duration-500"
                  >
                    comercial@sidom.io
                  </Link>
                </div>
              </div>
            </div>

            <div className="text-center px-6">
              <div className="relative overflow-hidden text-transparent -m-3">
                <FiHexagon className="h-28 w-28 mx-auto rotate-[30deg]" />
                <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto text-orange-500 rounded-xl transition-all duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
                  {/* Ubicación: icono pin moderno */}

                  <img src={location} alt="Ubicación" className="h-8 w-8" />
                </div>
              </div>

              <div className="content mt-7">
                <h5 className="title text-sidom-light text-lg font-medium">
                  Oficina Principal
                </h5>
                <p className="text-sidom-light mt-3">
                  Presencia comercial en 4 países, atención a nivel global{" "}
                  <br />
                  Camila O’Gorman 412 Piso 6<br />
                  Puerto Madero, Argentina
                </p>

                <div className="mt-5">
                  <Link
                    to="https://maps.app.goo.gl/bNKumrSVCpK6uhrH7"
                    data-type="iframe"
                    className="video-play-icon read-more lightbox text-orange-500 hover:text-orange-500 after:bg-orange-500 transition duration-500"
                  >
                    View on Google map
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="container-fluid relative">
        <div className="grid grid-cols-1">
          <div className="w-full leading-[0] border-0">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3283.331567481788!2d-58.36348442514557!3d-34.621060458412806!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a3358af2c37b9d%3A0xa9199bf5a230538b!2sCamila%20O&#39;Gorman%20412%20Piso%206%2C%20C1107%20Cdad.%20Aut%C3%B3noma%20de%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1745603572194!5m2!1ses!2sar"
              title="my-frame"
              className="w-full borde-0 h-[500px]"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
      <Footer />
      <Switcher />
    </div>
  );
}
